var render = function (_h,_vm) {var _c=_vm._c;return _c('section',{staticClass:"lyt-section",attrs:{"data-load":"layouts/section"}},[(_vm.headline)?_c('HeaderSection',{attrs:{"headline":_vm.props.headline,"copytext":_vm.props.copytext,"inverted":_vm.props.inverted}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }